import { render, staticRenderFns } from "./HcTabs.vue?vue&type=template&id=568016f2&scoped=true"
import script from "./HcTabs.vue?vue&type=script&lang=js"
export * from "./HcTabs.vue?vue&type=script&lang=js"
import style0 from "./HcTabs.vue?vue&type=style&index=0&id=568016f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568016f2",
  null
  
)

export default component.exports